import type { SearchContext } from '@shared/types/types';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';

const NO_COMPARISON_ID = null;

const CATEGORYPATHS_FOR_PRODUCT_COMPARISON_SQ = [
    'Fernseher',
    'Kaffeemaschinen>Kaffeevollautomaten',
    'Laptops',
    'Geschirrspüler',
    'Waschmaschinen>Frontlader',
    'Kühlschränke',
    'Kühlschränke>Kühl-Gefrierkombinationen',
    'Tablets',
    'Herde',
    'Sauger>Staubsauger',
    'Waschmaschinen',
    'Trockner>Wärmepumpentrockner',
    'Kaffeemaschinen',
    'Sauger>Staubsauger>Saugroboter',
    'Tablets>iPad',
    'Sauger>Staubsauger>Stielstaubsauger',
    'Backöfen',
    'Kochfelder',
    'Dunstabzugshauben',
    'no dominant value',
    'Trockner',
    'Laptops>Gaming-Notebooks',
    'Kaffeemaschinen>Kapselmaschinen',
    'Gefrierschränke>Tiefkühlschränke',
    'Kühlschränke>Side by Side Kühlschränke',
    'Waschtrockner',
    'Backöfen>Backofen-Sets',
    'Gefrierschränke',
    'Kaffeemaschinen>Filterkaffeemaschinen',
    'Waschmaschinen>Toplader',
    'Sauger>Staubsauger>Bodenstaubsauger',
    'Kaffeemaschinen>Espressomaschinen',
    'Tablets>iPad>iPad Pro',
    'Backöfen>Minibacköfen',
    'Trockner>Kondenstrockner',
    'Gefrierschränke>Gefriertruhen',
    'Kaffeemaschinen>Kaffeepadmaschinen',
    'Laptops>Surface',
    'Kühlschränke>Retrokühlschränke',
    'Sauger>Staubsauger>Handstaubsauger',
    'Kühlschränke>Minikühlschränke',
    'Dunstabzugshauben>Kopffreihauben',
    'Kühlschränke>Getränkekühlschränke',
    'Kühlschränke>Weinkühlschränke',
    'Kaffeemaschinen>Espressokocher',
    'Geschirrspüler>Tischgeschirrspüler',
    'Tablets>iPad>iPad Air',
    'Dunstabzugshauben>Wandhauben',
    'Trockner>Ablufttrockner',
    'Dampfgarer',
    'Dunstabzugshauben>Deckenhauben',
    'Kaffeemaschinen>Kaffeebereiter>French Press',
    'Dunstabzugshauben>Flachschirmhauben',
    'Backöfen>Pizzaöfen',
    'Dunstabzugshauben>Inselhauben',
    'Kaffeemaschinen>Kaffeebereiter',
    'Sauger>Staubsauger>Autostaubsauger',
    'Trockner>Wäscheschleudern',
    'Sauger>Nass-Trockensauger',
    'Tablets>iPad>iPad mini',
    'Grafiktabletts',
    'Tablets>Lerntablets',
    'eBook-Reader',
    'Sauger>Staubsauger>Matratzensauger',
    'Grills>Smoker',
    'Sauger>Staubsauger>Bürstsauger',
    'Dunstabzugshauben>Zwischenbauhauben',
    'Kaffeemaschinen>Kaffeebereiter>Handfilter',
    'Pfannen>Elektrische Pfannen',
    'Backformen>Dampfgarbehälter',
    'Wäscheständer>Wäschetürme',
    'Kaffeemaschinen>Kaffeebereiter>Perkolatoren',
    'Herde>Spiel-Herde',
    'Grills',
    'Toaster>2-Scheiben-Toaster',
    'Kondensatboxen',
    'Kaffeemaschinen>Kaffeebereiter>Cold Brew Kaffeebereiter',
    'Kaffeemaschinen>Kaffeebereiter>Soft Brew Kaffeebereiter',
    'Kocher>Reiskocher',
    'Laptops>Ultrabooks',
    'Grills>Gasgrills',
    'Waffeleisen-Ersatzplatten',
    'Babynahrungszubereiter',
    'Kocher>Multikocher',
    'Kochplatten>Doppelkochplatten',
    'Kocher>Gaskocher',
    'Sauger>Fenstersauger',
    'Mikrowellen',
    'Filter>Kaffeefilter',
    'Töpfe>Gemüsetöpfe',
    'Küchenmaschinen>Multifunktionsküchenmaschinen',
    'Räucheröfen',
    'Herde>Gasherde>Gasstandherde',
    'Filter>Kaffeefilter>Korbfilter',
    'Popcornmaschinen',
    'Hotdog-Maker',
    'Dosen>Frischhaltedosen',
    'Schneidemaschinen>Allesschneider',
    'Sauger>Dampfsauger',
    'Kochplatten>Einzelkochplatten',
    'Wischer>Wischbezüge',
    'Wischer>Bodenwischer',
    'Töpfe>Schmortöpfe',
    'Monitore>Gaming-Monitore',
    'Mixer>Stabmixer',
    'Mikrowellenbehälter',
    'Kannen>Kaffeekannen',
    'Warmhalteplatten',
    'Töpfe>Dampfgartöpfe',
    'Sauger>Hartbodenreiniger',
    'Pfannen',
    'Dörrautomaten',
    'Dosen>Brotdosen',
    'Dichtungsringe>Schnellkochtopf-Dichtungsringe',
    'Deckel>Topfdeckel',
] as const;

const CATEGORYPATHS_FOR_PRODUCT_COMPARISON_TESTGROUP = [
    'Akkus>Standard-Akkus',
    'Trainer>Crosstrainer',
    'E-Bikes',
    'Kinderfahrzeuge>Elektrofahrzeuge',
    'Motorroller',
    'Zahnbürsten',
    'Fahrräder',
    'Festplatten',
    'Haartrockner>Föhn',
    'Trainer>Fahrradtrainer',
    'Hochdruckreiniger',
    'Öfen>Kaminöfen',
    'Kraftstationen',
    'Spiele>Lernspiele',
    'Multistyler',
    'Puzzle',
    'Rasenmäher',
    'Trainer>Rudergeräte',
    'Rasenmäher>Rasentraktoren',
    'Scooter>Elektroscooter',
    'Solaranlagen',
    'Spiele',
    'Spielzeugfiguren',
    'Sonnenschirme',
    'Tastaturen',
    'Ventilatoren',
    'Kameras',
    'Computer>PC-Komplettsysteme',
    'Bügeleisen',
    'Computer',
    'Drohnen',
    'Drucker>Multifunktionsdrucker',
    'Fritteusen',
    'Grafikkarten',
    'Kopfhörer',
    'Lautsprecher',
    'Mobiltelefone',
    'Monitore',
    'Nähmaschinen',
    'Objektive',
    'Radios',
    'Router',
    'Smartwatches',
    'Spielekonsolen',
    'Konsolen-Spiele',
    'Wasserkocher',
    'Zerkleinerer',
    'Trainer>Fahrradtrainer>Heimtrainer',
    'Kraftstationen>Fitness-Stationen',
    'Puzzle>Standard-Puzzle',
    'Zahnbürsten>Elektrische Zahnbürsten',
];

function getCategoryPathSetNormalized(onex?: OnEx) {
    const isTestGroup = onex?.isExperimentGroup('COMPARISON_ADDITIONAL_CATEGORIES', 'E3695B') ?? false;
    const categoryPaths = isTestGroup
        ? [...CATEGORYPATHS_FOR_PRODUCT_COMPARISON_SQ, ...CATEGORYPATHS_FOR_PRODUCT_COMPARISON_TESTGROUP]
        : CATEGORYPATHS_FOR_PRODUCT_COMPARISON_SQ;
    return new Set(categoryPaths.map((item) => item.toLowerCase()));
}

const TESTGROUP_CATEGORY_PATH_SET_NORMALIZED = new Set(
    CATEGORYPATHS_FOR_PRODUCT_COMPARISON_TESTGROUP.map((item) => item.toLowerCase()),
);

export type ComparisonResult = {
    /*                                                      */
    whatIf: boolean;
    /*                                                    */
    comparisonId: string | null;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function extractComparisonId(
    searchContext?: SearchContext,
    comparisonIdQueryParam?: string,
    onex?: OnEx,
): ComparisonResult {
    /*                                                                                                                                                   */
    if (comparisonIdQueryParam) {
        return { whatIf: false, comparisonId: comparisonIdQueryParam };
    }
    const { categoryPath, pbk } = searchContext ?? {};

    if (!categoryPath || !pbk) {
        return { whatIf: false, comparisonId: NO_COMPARISON_ID };
    }

    const comparisonId = getCategoryPathSetNormalized(onex).has(categoryPath.toLowerCase()) ? pbk : NO_COMPARISON_ID;

    const whatIf =
        TESTGROUP_CATEGORY_PATH_SET_NORMALIZED.has(categoryPath.toLowerCase()) &&
        (onex?.isExperimentActive('COMPARISON_ADDITIONAL_CATEGORIES') ?? false) &&
        !!pbk;

    return { whatIf, comparisonId };
}
